import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  const [old_password, setOld] = useState("");
  const [new_password, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const save = async () => {
    if (new_password !== confirm) { toast.error("Konfirmasi tidak cocok"); return; }
    try { await api.put("/auth/change-password", {old_password, new_password}); toast.success("Password diubah"); setOld(""); setNew(""); setConfirm(""); }
    catch(e){ toast.error(formatApiError(e)); }
  };
  return (<>
    <PageHeader title="Profil Akun" subtitle="Kelola data akun & password Anda."/>
    <div className="p-4 md:p-8 grid md:grid-cols-2 gap-5">
      <div className="card-flat p-6 space-y-3">
        <h3 className="font-semibold text-slate-900">Informasi Akun</h3>
        <div><Label>Nama</Label><Input value={user?.name||""} disabled/></div>
        <div><Label>Email</Label><Input value={user?.email||""} disabled/></div>
        <div><Label>Peran</Label><Input value={user?.role||""} disabled/></div>
      </div>
      <div className="card-flat p-6 space-y-3">
        <h3 className="font-semibold text-slate-900">Ubah Password</h3>
        <div><Label>Password Lama</Label>
          <div className="relative">
            <Input type={show?"text":"password"} value={old_password} onChange={(e)=>setOld(e.target.value)}/>
            <button type="button" onClick={()=>setShow(!show)} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500">{show?<EyeOff size={16}/>:<Eye size={16}/>}</button>
          </div>
        </div>
        <div><Label>Password Baru</Label><Input type={show?"text":"password"} value={new_password} onChange={(e)=>setNew(e.target.value)}/></div>
        <div><Label>Konfirmasi</Label><Input type={show?"text":"password"} value={confirm} onChange={(e)=>setConfirm(e.target.value)}/></div>
        <Button onClick={save} className="brand-btn rounded-sm">Simpan Password</Button>
      </div>
    </div>
  </>);
}
